import PopOutIcon from "./_images/pop-out-btn.svg";

interface IPopoutButtonProps {
    onPopoutClick: () => void;
}

export function PopoutButton(props: IPopoutButtonProps): JSX.Element {
    return <button onClick={() => props.onPopoutClick()}><PopOutIcon /></button>;
}
